import React from 'react'
import { imgs } from '../../assets/imgs'
import { icons } from '../../assets/icons'

export const ModalInsings = ({ insigImg, title, xp, onClose }) => {
	return (
		<div className="w-[248px] md:w-[480px] h-[328px] md:h-[600px] bg-white rounded-2xl px-7 ">
			<div className='w-full pt-4 md:pt-7 flex justify-end'>
				<img
					onClick={() => { onClose(false) }}
					src={icons.closeRed} className='w-5 md:w-9 h-5 md:h-9 object-cover cursor-pointer' alt="" />
			</div>
			<div className='w-full h-[142px] md:h-[275px] rounded-lg bg-rose-200 mt-4 md:mt-9 flex justify-center items-center relative'>
				<img src={imgs.background_insigModal} className='w-full h-full object-cover' alt="" />
				<img src={insigImg} className='absolute w-[92px] md:w-[170px] h-[92px] md:h-[170px] object-cover' alt="insign modal" />
			</div>
			<div className='w-full h-5 md:h-11 bg-[#F59E0B] flex justify-center items-center'>
				<p className='text-white text-[9px] md:text-base font-semibold'>{title}</p>
			</div>
			<div className='w-full mt-2 md:mt-4 flex flex-col items-center '>
				<div className='w-[74px] h-[33px] bg-[#282828] flex justify-center items-center rounded-lg'>
					<img src={icons.xpicon} className='transform -translate-x-5' alt="" />
					<p className='text-white text-sm font-bold transform -translate-x-3'>{xp}</p>
				</div>
				<p className='text-black text-8 md:text-base font-bold' >Puntos obtenidos</p>
			</div>
			<div className='w-full mt-2 md:mt-5 flex justify-center '>
				<button
					onClick={() => { onClose(false) }}
					className=' w-[92px] md:w-[156px] h-[28px] md:h-16 bg-[#FFC427] text-white text-base md:text-[32px] font-semibold rounded-lg shadowbtnout cursor-pointer'>
					Regresar
				</button>
			</div>
		</div>
	)
}
